<script>
import IconWrapper from './IconWrapper.vue'
import IconCertificateSvg from '@/assets/img/icons/IconCertificate.svg'

export default {
  name: 'IconCertificate',
  components: {
    IconWrapper
  },
  computed: {
    svg () {
      return IconCertificateSvg
    }
  }
}
</script>

<template>
  <IconWrapper v-html="svg" class="IconCertificate" />
</template>
